import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';
import { Row, Col } from 'antd';
import { keyBy, find, get, cloneDeep } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import helpers from 'utils/helpers';
import currency from 'utils/currency';
import countries from 'data/countries';
import ImagePlane from 'assets/images/plane-black.svg';
import { getTransactionsRequest, getPaymentMethodRequest } from 'ducks/users';
import { confirmAdjustmentRequest } from 'ducks/shipments';
import TransactionAdjustmentContent from './TransactionAdjustmentContent';
import PushUpDrawer from 'components/common/PushUpDrawer';
import ConfirmDrawer from 'components/common/ConfirmDrawer';
import {
  TransactionCardTitle,
  StyledButton,
  ChargeRow
} from 'components/Styled';

const ORDER_NORMAL = 0;
const ORDER_RETURN = 2;

class TransactionAdjustment extends Component {
  state = {
    uiLoaded: false,
    loading: false,
    drawerVisible: false,
    confirmVisible: false
  };

  authentication = () => {
    if (this.props.user) {
      if (
        !this.props.transactions ||
        (this.props.location.state !== undefined &&
          this.props.location.state.reschedulePickupSuccess)
      ) {
        this.props.getTransactionsRequest({ user: this.props.user });
      } else {
        this.setState({
          uiLoaded: true
        });
      }

      if (!this.props.paymentMethodDetail) {
        this.props.getPaymentMethodRequest({
          paymentType: 'stripe',
          user: this.props.user
        });
      }
    } else if (this.props.user === false) {
      this.props.history.push(`${process.env.PUBLIC_URL}/login`);
    }
  };

  handleOriginExpand = () => {
    this.setState({
      originExpand: !this.state.originExpand
    });
  };

  handleDestinationExpand = () => {
    this.setState({
      destinationExpand: !this.state.destinationExpand
    });
  };

  handleConfirmClick = () => {
    this.setState({
      loading: true
    });

    const confirm = true;
    const transaction = find(this.props.transactions, {
      ref: this.props.match.params.ref
    });

    const shipment = get(transaction, 'shipments[0]') || {};

    this.props.confirmAdjustmentRequest({
      transactionRef: transaction.ref,
      shipmentRef: shipment.ref,
      confirm
    });
  };

  handleSubmitClick = () => {
    this.setState({
      confirmVisible: !this.state.confirmVisible
    });
  };

  handleReturnClick = () => {
    if (this.props.handleBusinessStep) {
      this.props.handleBusinessStep(ORDER_RETURN);
    } else {
      const transaction = find(this.props.transactions, {
        ref: this.props.match.params.ref
      });
      this.props.history.push(
        `${process.env.PUBLIC_URL}/account/orders/return/${transaction.ref}`
      );
    }
  };

  setDrawerVisible = () => {
    if (this.props.handleRefresh && this.state.drawerVisible)
      this.props.handleRefresh();
    this.setState({
      drawerVisible: !this.state.drawerVisible
    });
  };

  setConfirmVisibleVisible = () => {
    this.setState({
      confirmVisible: !this.state.confirmVisible
    });
  };

  handleSuccessClick = () => {
    this.props.history.push({
      pathname: `${process.env.PUBLIC_URL}/account/orders/`
    });
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.user !== this.props.user) {
      this.authentication();
    }
    if (
      !this.props.confirmAdjustmentSuccess &&
      !this.props.data &&
      prevProps.transactions !== this.props.transactions
    ) {
      const transaction = find(this.props.transactions, {
        ref: this.props.match.params.ref
      });
      if (transaction.status !== 4) {
        this.props.history.push(
          `${process.env.PUBLIC_URL}/account/orders/${transaction.ref}`
        );
      }
      // const trackingNumber = get(transaction, 'shipments[0].trackingNumber');
      // window.dataLayer.push({
      //   event: 'Land Shipment Tracking Page',
      //   trackingNumber
      // });
    }

    if (prevProps.uiLoading && !this.props.uiLoading) {
      this.setState({
        uiLoaded: true
      });
    }

    if (
      prevProps.confirmAdjustmentLoading &&
      !this.props.confirmAdjustmentLoading &&
      !this.props.confirmAdjustmentSuccess
    ) {
      this.setState({
        loading: false
      });
    }

    if (
      !prevProps.confirmAdjustmentSuccess &&
      this.props.confirmAdjustmentSuccess
    ) {
      this.props.getTransactionsRequest({ user: this.props.user });
      return;
    }
    if (
      prevProps.confirmAdjustmentSuccess &&
      prevProps.transactions !== this.props.transactions
    ) {
      this.setState({
        loading: false
      });

      this.setState({
        confirmVisible: false
      });

      this.setState({
        drawerVisible: true
      });
    }
  }

  componentDidMount() {
    this.authentication();
  }

  render() {
    const TRANSACTION_HOLD = 4;
    const countriesData = keyBy(this.props.countries, 'alpha-2');
    let transaction = null;
    if (this.props.data) {
      transaction = cloneDeep(this.props.data);
    } else {
      transaction = find(this.props.transactions, {
        ref: this.props.match.params.ref
      });
    }

    const shipment = get(transaction, 'shipments[0]') || {};
    const chargeDiff = new currency(get(transaction, 'chargeDifference') || 0);
    const shipments = get(transaction, 'shipments');

    let paid, finalCharges;
    if (shipments && shipments.length === 1) {
      paid = transaction.totalCharges;
      finalCharges = transaction.finalTotal;
    } else {
      paid = shipment.firstRate;
      finalCharges = shipment.TotalRate;
    }

    paid = new currency(paid);
    finalCharges = new currency(finalCharges);

    shipment.finalTotalRate = shipment.finalTotalRate || shipment.totalRate;

    if (!transaction && this.state.uiLoaded) {
      this.props.history.push(`${process.env.PUBLIC_URL}/account/orders`);

      return null;
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>
            {`${this.props.t('transactions.my_items')}`}
            {shipment.trackingNumber
              ? `(TRK# ${shipment.trackingNumber})`
              : ''}{' '}
            | Spaceship
          </title>
        </Helmet>
        {transaction ? (
          <React.Fragment>
            {/* <!-- Header --> */}
            <div
              className="transaction-adjustment-container"
              style={{
                backgroundColor: '#f5f5f5',
                margin: '0 auto',
                width: '100%',
                height: '100%',
                maxWidth: `${process.env.REACT_APP_MAX_WIDTH}px`
              }}>
              <div
                style={{
                  paddingBottom: '10px',
                  display:
                    this.state.uiLoaded || this.props.isBusines
                      ? 'block'
                      : 'none'
                }}>
                <div
                  style={{
                    padding: '20px 0',
                    textAlign: 'center',
                    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.2)',
                    backgroundColor: '#fff',
                    position: 'relative',
                    marginBottom: '10px'
                  }}>
                  <div
                    className="back-button"
                    style={{
                      fontSize: '12px',
                      position: 'absolute',
                      top: '0px',
                      left: '0px',
                      padding: '20px 15px',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      if (this.props.handleBusinessStep) {
                        this.props.handleBusinessStep(ORDER_NORMAL);
                      } else {
                        this.props.history.push(
                          `${process.env.PUBLIC_URL}/account/orders`
                        );
                      }
                    }}>
                    <FontAwesomeIcon icon="angle-left" />
                  </div>
                  <TransactionCardTitle className="transaction-detail-title buttonTheme-color">
                    {`${this.props.t('confirmAdjustment.header')} `}
                  </TransactionCardTitle>
                  <div style={{ fontSize: '12px' }}>
                    <div
                      style={{ display: 'inline-block', paddingRight: '10px' }}>
                      {helpers.responsiveImage(
                        helpers.getCarrierImage(
                          shipment.carrierService.carrier
                        ),
                        helpers.getCarrierText(shipment.carrierService.carrier),
                        helpers.getCarrierImageWidth(
                          shipment.carrierService.carrier,
                          0.8
                        )
                      )}
                    </div>
                    <span style={{ verticalAlign: 'middle' }}>
                      {get(shipment.carrierService.name, this.props.t('key'))}
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: '20px',
                      fontWeight: 700,
                      padding: '7px 0 5px'
                    }}>
                    {get(
                      countriesData[shipment.fromAddress.country],
                      `name.${this.props.t('key')}`
                    )}
                    <img
                      src={ImagePlane}
                      style={{
                        width: '31.3px',
                        paddingBottom: '2px',
                        margin: '0 6px'
                      }}
                      alt=""
                    />
                    {get(
                      countriesData[shipment.toAddress.country],
                      `name.${this.props.t('key')}`
                    )}
                  </div>
                  <br />
                  <div>
                    <div style={{ fontSize: '12px' }}>
                      {this.props.t('finish.tracking_link')}
                      <a
                        style={{ color: '#9900A5' }}
                        href={helpers.getCarrierTrackingUrl(
                          shipment.carrierService.carrier,
                          shipment.trackingNumber
                        )}
                        className="buttonTheme-color"
                        target="_blank"
                        rel="noopener noreferrer">
                        {shipment.trackingNumber}{' '}
                        <FontAwesomeIcon icon="angle-right" />
                      </a>
                    </div>
                  </div>
                </div>
                {/* <!-- End Header --> */}
                <TransactionAdjustmentContent
                  shipment={shipment}
                  transaction={transaction}
                />
              </div>
              {get(transaction, 'status') === TRANSACTION_HOLD ? (
                <>
                  <div
                    className="actions-btn-group"
                    style={{ paddingBottom: '10px', textAlign: 'center' }}>
                    <StyledButton
                      type="primary"
                      shadow="true"
                      width={201}
                      onClick={this.handleSubmitClick}
                      disabled={this.state.loading}>
                      {this.props.t('confirmAdjustment.btnNeedPay', {
                        amount: chargeDiff.format()
                      })}
                    </StyledButton>
                  </div>
                  <div
                    className="actions-btn-group"
                    style={{ paddingBottom: '60px', textAlign: 'center' }}>
                    <StyledButton
                      ghost
                      type="secondary"
                      width={201}
                      onClick={this.handleReturnClick}
                      disabled={this.state.loading}
                      className="theme-button">
                      {this.props.t('confirmAdjustment.return')}
                    </StyledButton>
                  </div>
                </>
              ) : null}
              <PushUpDrawer
                containerClasses={
                  this.props.data ? 'business-adjustment-drawer' : ''
                }
                visible={this.state.drawerVisible}
                onClose={this.setDrawerVisible}
                title={this.props.t('confirmAdjustment.paymentSuccess')}
                subTitle={this.props.t('confirmAdjustment.paymentSubTitle')}
                btnTitle={this.props.t('confirmAdjustment.backToShipment')}
                btnClick={this.handleSuccessClick}
              />
              <ConfirmDrawer
                visible={this.state.confirmVisible}
                onClose={this.setConfirmVisibleVisible}
                title={this.props.t('confirmAdjustment.confirmAdjustment')}
                subTitle={this.props.t('confirmAdjustment.paymentSubTitle')}
                btnTitle={this.props.t('confirmAdjustment.pay')}
                btnLoading={this.state.loading}
                height={350}
                btnClick={this.handleConfirmClick}>
                <ChargeRow type="flex" align="bottom" className="p-t-10">
                  <Col span={12} className="text-left">
                    {this.props.t('confirmAdjustment.adjustmentCharges')}
                  </Col>
                  <Col span={12} className="text-right">
                    {finalCharges.format()}
                  </Col>
                </ChargeRow>
                <ChargeRow type="flex" align="bottom">
                  <Col span={12} className="text-left">
                    {this.props.t('confirmAdjustment.paid')}
                  </Col>
                  <Col span={12} className="text-right">
                    {paid.multiply(-1).format()}
                  </Col>
                </ChargeRow>
                <ChargeRow
                  style={{ fontWeight: 700 }}
                  type="flex"
                  align="bottom">
                  <Col span={12} className="text-left">
                    {this.props.t('confirmAdjustment.needPay')}
                  </Col>
                  <Col span={12} className="text-right">
                    {chargeDiff.format()}
                  </Col>
                </ChargeRow>
                {this.props.paymentMethodDetail &&
                this.props.paymentMethodDetail.brand ? (
                  <Row className="xsmall-font">
                    {this.props.paymentMethodDetail.brand.toUpperCase()} ••••{' '}
                    {this.props.paymentMethodDetail.last4}
                  </Row>
                ) : null}
              </ConfirmDrawer>
            </div>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  getTransactionsRequest,
  getPaymentMethodRequest,
  confirmAdjustmentRequest
};

const mapStateToProps = state => {
  return {
    user: state.auth.user,
    authRequestSuccess: state.auth.authRequestSuccess,
    uiLoading: !!state.users.loading,
    transactions: get(state, 'users.transactions.data') || false,
    confirmAdjustmentSuccess: state.shipments.confirmAdjustmentSuccess || false,
    confirmAdjustmentLoading: !!state.shipments.loading,
    countries: state.shipments.countries || countries,
    paymentMethodDetail: state.users.paymentMethodDetail || false
  };
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(TransactionAdjustment))
);
